let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gXe1h")).then(() => parcelRequire('lLLY3'));